import AOS from 'aos';

$(function() {
    AOS.init({
        once: true,
    });
});
